module.exports = __webpack_public_path__ + "static/media/DeadlineImage.31ef1e2f.png";